import * as $ from 'jquery';
import * as _ from 'underscore';

import RoomTypeDescription from '../models/RoomTypeDescription';

export default class RoomTypeDescriptionRepository {

    findAll(): JQueryPromise<RoomTypeDescription[]> {
        return $.when([
            new RoomTypeDescription( 'Motel Room', undefined, 'motel-room', '/images/motel_room_l.jpg', 4,
                                     [['Two to four people occupancy', true],
                                      '40" TV',
                                      'Desk and Chair',
                                      'Dresser',
                                      '2 Double Beds',
                                      'Microwave',
                                      'Mini-Refrigerator',
                                      'Air Conditioning and Heating',
                                      'Telephone',
                                      'Alarm Clock Radio',
                                      'Full Closet with Luggage Rack',
                                      'Private Bath with Standard Tub/Shower',
                                      'Complimentary Wireless Internet',
                                      'Maximum Occupancy of 4 persons'] ),

            new RoomTypeDescription( 'Efficiency Room', undefined, 'efficiency-room', '/images/efficiency_room_l.jpg', 4,
                                     [['Two to four people occupancy', true],
                                      '40" TV',
                                      'Desk and Chair',
                                      'Dresser',
                                      '2 Double Beds',
                                      'Kitchen Table with Chairs',
                                      'Microwave',
                                      'Full Refrigerator',
                                      'Fully Equipped Kitchen with Pots, Pans, Utensils, Coffee Maker, Toaster, and Stove/Oven',
                                      'Air Conditioning and Heating',
                                      'Telephone',
                                      'Alarm Clock Radio',
                                      'Full Closet with Luggage Rack',
                                      'Ironing Board',
                                      'Private Bath with Standard Tub/Shower',
                                      'Complimentary Wireless Internet',
                                      'Maximum Occupancy of 4 persons',
                                      'Choice of lower or upper level by availability'
                                     ] ),

            new RoomTypeDescription( 'Bedroom Suite', 'Efficiency Apt.', 'bedroom-suite', '/images/bedroom_suite_l.jpg', 6,
                                     [['Two to six people occupancy', true],
                                      '40" TV',
                                      'Desk and Chair',
                                      'Dresser',
                                      '2 Double Beds',
                                      'Kitchen Table with Chairs',
                                      'Microwave',
                                      'Full Refrigerator',
                                      'Fully Equipped Kitchen with Pots, Pans, Utensils, Coffee Maker, Toaster, and Stove/Oven',
                                      'Air Conditioning and Heating',
                                      'Telephone',
                                      'Alarm Clock Radio',
                                      'Full Closet with Luggage Rack',
                                      'Ironing Board',
                                      'Private Bath with Standard Tub/Shower',
                                      'Complimentary Wireless Internet',
                                      'Maximum Occupancy of 6 persons',
                                      'Choice of lower or upper level by availability'] )
        ]);
    }

    findByTypeName( typename: string ): JQueryPromise<RoomTypeDescription> {
        return this.findAll().then( data => _.findWhere(data, { name: typename }) );
    }

}



/** WEBPACK FOOTER **
 ** ./src/repositories/RoomTypeDescriptionRepository.ts
 **/